import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa279a72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overview" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-left" }, " 宇涵物流订单系统 是基于 Vue3、Vuex、VueRouter、Vite、 ElementPlus 、TypeScript、Echart5 等后台系统解决方案。 ", -1))
const _hoisted_3 = { class: "c-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_yh_card = _resolveComponent("yh-card")!
  const _component_yh_text_link = _resolveComponent("yh-text-link")!
  const _component_yh_descriptions = _resolveComponent("yh-descriptions")!
  const _component_yh_code = _resolveComponent("yh-code")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_yh_card, { title: "关于" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_yh_card, { title: "技术栈" }, {
      default: _withCtx(() => [
        _createVNode(_component_yh_text_link, { "text-arrs": _ctx.technologyStacks }, null, 8, ["text-arrs"]),
        _createVNode(_component_yh_descriptions, {
          title: "生产环境依赖",
          column: 2,
          "table-datas": _ctx.dependencies
        }, null, 8, ["table-datas"]),
        _createVNode(_component_yh_descriptions, {
          title: "开发环境依赖",
          column: 2,
          "table-datas": _ctx.devDependencies
        }, null, 8, ["table-datas"])
      ]),
      _: 1
    }),
    _createVNode(_component_yh_card, { title: "项目结构" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_yh_code, {
            language: "bash",
            code: _ctx.projectDir
          }, null, 8, ["code"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_yh_card, { title: "项目规范" }, {
      default: _withCtx(() => [
        _createVNode(_component_yh_descriptions, {
          title: "文件命名规范",
          column: 1,
          "table-datas": [
          { name: '文件夹', description: '统一小写, 多个单词使用-分割' },
          {
            name: '文件(.ts .vue .json .d.ts)',
            description: '统一小写, 多个单词使用-分割'
          }
        ]
        }, null, 8, ["table-datas"]),
        _createVNode(_component_yh_descriptions, {
          title: "编写组件规范",
          column: 1,
          "table-datas": [
          { name: '组件的文件', description: '统一小写, 多个单词使用-分割' },
          {
            name: '组件的目录结构',
            description:
              '例如 button 组件：button/src/index.vue, 统一在button/index.ts导出'
          },
          {
            name: '组件导包顺序',
            description:
              '导vue技术栈的包 , 导第三方的工具函数 , 导本地的组件, 导本地的工具函数'
          },
          { name: '组件的名称', description: '统一大写开头，驼峰命名' },
          {
            name: '组件属性顺序',
            description: 'name, components, props, emits, setup ...'
          },
          {
            name: 'template标签',
            description: '小写加 - ( 例如：<case-panel/> )'
          },
          {
            name: 'template标签属性顺序',
            description: 'v-if , v-for , ref, class, style, ... ,事件'
          },
          {
            name: '组件的props',
            description: '小写开头，驼峰命名，必须编写类型默认值'
          },
          {
            name: '组件的样式',
            description:
              '作用域：scoped, lang = scss / less  ; 类名：统一小写, 多个单词使用-分割'
          }
        ]
        }, null, 8, ["table-datas"])
      ]),
      _: 1
    }),
    _createVNode(_component_yh_card, { title: "Git提交规范" }, {
      default: _withCtx(() => [
        _createVNode(_component_yh_descriptions, {
          column: 1,
          "table-datas": [
          { name: 'add 操作', description: 'git add ' },
          { name: 'commit 操作', description: 'yarn commit ' },
          { name: 'pull 操作', description: 'git pull ' },
          { name: 'push 操作', description: 'git push ' }
        ]
        })
      ]),
      _: 1
    })
  ]))
}